if (!customElements.get('media-lightbox-opener')) {
  customElements.define(
    'media-lightbox-opener',
    class MediaLightboxOpener extends HTMLElement {
      constructor() {
        super();

        this.image = this.querySelector('img');
        this.lightbox = document.getElementById('MediaGalleryLightboxPSWP');

        if (this.image) {
          this.image.addEventListener('click', this.openPhotoSwipe.bind(this));
        }
      }

      openPhotoSwipe(e) {
        const items = this.getLightboxItems();
        const currentIndex = items.findIndex((item) => item.index === parseInt(this.getAttribute('position')));
        const options = {
          index: currentIndex,
          shareEl: false,
          closeOnScroll: false,
          history: false,
          hideAnimationDuration: 0,
          showAnimationDuration: 0,
        };

        const lightbox = new PhotoSwipe(this.lightbox, PhotoSwipeUI_Default, items, options);

        lightbox.init();
      }

      getLightboxItems() {
        const list = document.getElementById(this.dataset.gallery);
        const items = [];

        if (list) {
          list.querySelectorAll('media-lightbox-opener').forEach((item) => {
            items.push({
              alt: item.image.getAttribute('alt'),
              src: item.image.getAttribute('src'),
              w: parseInt(item.image.getAttribute('width')),
              h: parseInt(item.image.getAttribute('height')),
              index: parseInt(item.getAttribute('position')),
            });
          });

          // Sort items by index
          items.sort((a, b) => a.index - b.index);
        }

        return items;
      }
    }
  );
}

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          slides: this.querySelectorAll('.gallery-list__item'),
        };
        this.mql = window.matchMedia('(min-width: 992px)');
        this.layout = this.dataset.desktopLayout;
        this.isSlider = 'stacked' !== this.layout && 'columns' !== this.layout;
        this.gallerySlider = null;
        this.thumbnailsSlider = null;

        this.initThumbnailSlider();

        if (this.shouldInitSlider()) {
          this.initGallerySlider();
        }

        if (!this.isSlider) {
          this.mql.addEventListener('change', this.toggleSlider.bind(this));
        }
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.scrollToTop();
          }
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      shouldInitSlider() {
        if (this.elements.slides.length < 2) {
          return false;
        }

        if (this.isSlider || !this.mql.matches) {
          return true;
        }

        return false;
      }

      initThumbnailSlider() {
        if (!this.elements.thumbnails) {
          return;
        }

        if (this.elements.slides.length < 2) {
          return;
        }

        const options = {
          // watchSlidesProgress: true,
          slidesPerView: 'auto',
          spaceBetween: 10,
          navigation: {
            nextEl: this.elements.thumbnails.querySelector('.swiper-button-next'),
            prevEl: this.elements.thumbnails.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            0: {
              direction: 'horizontal',
              spaceBetween: 10,
            },
            992: {
              direction: 'thumbnails-left' == this.layout ? 'vertical' : 'horizontal',
              spaceBetween: 20,
            },
          },
        };

        this.thumbnailsSlider = new Swiper(this.elements.thumbnails, options);
      }

      initGallerySlider() {
        if (this.elements.slides.length < 2) {
          return;
        }

        const options = {
          loop: true,
          slidesPerView: 1,
          allowTouchMove: true,
          lazy: true,
          pagination: {
            el: this.elements.viewer.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'bullets',
          },
          thumbs: {
            swiper: this.thumbnailsSlider ?? false,
          },
          navigation: {
            nextEl: this.elements.viewer.querySelector('.swiper-button-next'),
            prevEl: this.elements.viewer.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            0: {
              spaceBetween: 10,
            },
            992: {
              spaceBetween: 0,
            },
          },
        };

        if ('carousel' === this.layout) {
          options.watchOverflow = true;
          options.centeredSlides = true;
          options.slidesPerView = 'auto';

          if (this.elements.slides.length < 4) {
            options.loop = false;
          }
        }

        this.gallerySlider = new Swiper(this.elements.viewer, options);

        this.setAttribute('slider', true);
      }

      destroyGallerySlider() {
        if (!this.gallerySlider) {
          return;
        }

        this.gallerySlider.destroy(true, true);
        this.gallerySlider = null;
        this.elements.slides.forEach((el) => el.removeAttribute('style'));

        this.removeAttribute('slider');
      }

      toggleSlider() {
        if (this.mql.matches && !this.isSlider) {
          this.destroyGallerySlider();
        } else {
          this.initGallerySlider();
        }
      }

      scrollToTop() {
        if (!this.isSlider && this.mql.matches) {
          window.scrollTo({
            top: this.elements.viewer.offsetTop,
            behavior: 'smooth',
          });
        }
      }
    }
  );
}
